import React from "react";

import { siteLocationPrefix } from "../../constants";
import { Programs } from "../../models/programsConfig";
import { TestButton } from "./TestButton";
import * as styles from "./TestStyle.module.css";

export const TestAaaActions = () => (
  <div className={styles.aaaActionsWrapper}>
    <h3>Hub Access Actions</h3>
    <TestButton
      type={Programs.Aaa}
      url={`${siteLocationPrefix}/test/setAccountType?type=aaa`}
      title="Change account type to AAA"
    />
    <TestButton
      type={Programs.IdXbox}
      url={`${siteLocationPrefix}/test/setAccountType?type=id`}
      title="Change account type to ID"
    />
    <TestButton
      type={Programs.Aaa}
      url={`${siteLocationPrefix}/test/setAccountHubAccess?type=aaa`}
      title="Set account Hub access to AAA"
    />
    <TestButton
      type={Programs.Aaa}
      url={`${siteLocationPrefix}/test/setAccountHubAccess?type=onboarding`}
      title="Set account Hub access to ID"
    />
    <TestButton
      type={Programs.Aaa}
      url={`${siteLocationPrefix}/test/setAccountHubAccess?type=none`}
      title="Clear account Hub access"
    />
    <TestButton
      type={Programs.Aaa}
      url={`${siteLocationPrefix}/test/setOnboardingUserIdToContact`}
      title="Grant current Contact Hub login access"
    />
  </div>
);
